export default __webpack_public_path__ + "static/media/on_4.942814b3.mp3";